import { styled } from 'styled-components';

export const ScScratchBonusTerms = styled.div<{ isOpen: boolean }>`
  position: relative;
  margin-top: 4px;

  & .header {
    padding-bottom: 24px;
  }

  .content-box {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows 0.2s ease 0s;

    & .content {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      word-break: break-word;
      text-align: left;
    }

    & .bonus {
      text-transform: capitalize;
    }
  }
`;
